var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isActive ? _c('div', {
    staticClass: "shop"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "confetti-container"
    }
  }), _c('PaymentModal', {
    ref: "payment_modal",
    attrs: {
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    }
  }), _c('div', {
    staticClass: "tab-pane fade position-relative",
    class: {
      'show active': _vm.isActive
    },
    attrs: {
      "id": "nav-in-game-shop",
      "role": "tabpanel",
      "aria-labelledby": "nav-in-game-shop-tab",
      "tabindex": "2"
    }
  }, [_c('div', {
    staticClass: "topup"
  }, [_c('div', {
    staticClass: "gem"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/gem.png",
      "alt": "Gem Icon"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.userGems))]), _c('b-button', {
    staticClass: "btn-add",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.activateChildTab(1);
      }
    }
  }, [_vm._v("+")])], 1), _c('div', {
    staticClass: "coin"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/coin.png",
      "alt": "Coin Icon"
    }
  }), _c('span', [_vm._v(" " + _vm._s(_vm.userCoins))]), _c('b-button', {
    staticClass: "btn-add",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.activateChildTab(0);
      }
    }
  }, [_vm._v("+")])], 1)]), _c('b-tabs', {
    attrs: {
      "content-class": "category"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Bike",
      "active": ""
    }
  }, [_c('Bike', {
    attrs: {
      "frames": _vm.frames,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins,
      "wheels": _vm.wheels
    },
    on: {
      "activateModalParent": _vm.activateChildTab
    }
  })], 1), false ? _c('b-tab', {
    attrs: {
      "title": "AVATAR"
    }
  }, [_c('Avatar', {
    attrs: {
      "head": _vm.head,
      "hair": _vm.hair,
      "facial-hair": _vm.facialHair,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalParent": _vm.activateChildTab
    }
  })], 1) : _vm._e(), _c('b-tab', {
    attrs: {
      "title": "APPAREL"
    }
  }, [_c('Apparel', {
    attrs: {
      "gloves": _vm.gloves,
      "socks": _vm.socks,
      "shoes": _vm.shoes,
      "jerseys": _vm.jerseys,
      "glasses": _vm.glasses,
      "helmet": _vm.helmet,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalParent": _vm.activateChildTab
    }
  })], 1)], 1)], 1)], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }